import { render, staticRenderFns } from "./pg_humanrights.vue?vue&type=template&id=0d64dc56"
import script from "./pg_humanrights.vue?vue&type=script&lang=js"
export * from "./pg_humanrights.vue?vue&type=script&lang=js"
import style0 from "./pg_humanrights.vue?vue&type=style&index=0&id=0d64dc56&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports